import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateSmsMessageMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  status: Types.Scalars['String']['input'];
}>;


export type UpdateSmsMessageMutation = { __typename?: 'mutation_root', update_smsmessages_by_pk?: { __typename?: 'smsmessages', id: number, status?: string | null, updatedat?: string | null } | null };


export const UpdateSmsMessageDocument = gql`
    mutation updateSmsMessage($id: bigint!, $status: String!) {
  update_smsmessages_by_pk(pk_columns: {id: $id}, _set: {status: $status}) {
    id
    status
    updatedat
  }
}
    `;
export type UpdateSmsMessageMutationFn = Apollo.MutationFunction<UpdateSmsMessageMutation, UpdateSmsMessageMutationVariables>;

/**
 * __useUpdateSmsMessageMutation__
 *
 * To run a mutation, you first call `useUpdateSmsMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmsMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSmsMessageMutation, { data, loading, error }] = useUpdateSmsMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateSmsMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSmsMessageMutation, UpdateSmsMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSmsMessageMutation, UpdateSmsMessageMutationVariables>(UpdateSmsMessageDocument, options);
      }
export type UpdateSmsMessageMutationHookResult = ReturnType<typeof useUpdateSmsMessageMutation>;
export type UpdateSmsMessageMutationResult = Apollo.MutationResult<UpdateSmsMessageMutation>;
export type UpdateSmsMessageMutationOptions = Apollo.BaseMutationOptions<UpdateSmsMessageMutation, UpdateSmsMessageMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/mutations/updateSmsMessage.mutation.gql}
 */
export async function updateSmsMessage(
  variables: UpdateSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateSmsMessageMutation['update_smsmessages_by_pk']>
export async function updateSmsMessage(
  variables: UpdateSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateSmsMessageMutation>
export async function updateSmsMessage(
  variables: UpdateSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateSmsMessageMutation['update_smsmessages_by_pk'] | UpdateSmsMessageMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateSmsMessageMutation>(
    UpdateSmsMessageDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_smsmessages_by_pk
}